import { OrderStatus } from '../models/orders/orderStatus';

export const orderStatusColor = (status: OrderStatus): string => {
  switch (status) {
    case OrderStatus.Pending:
      return '#483D8B';
    case OrderStatus.Processing:
      return '#FF8C00';
    case OrderStatus.Ready:
      return '#228B22';
    case OrderStatus.Cancelled:
      return '#DC143C';
    default:
      return 'gray';
  }
};

export const orderStatusLabel = (status: OrderStatus): string => {
  switch (status) {
    case OrderStatus.Pending:
      return 'orders.status.pending';
    case OrderStatus.Processing:
      return 'orders.status.processing';
    case OrderStatus.Ready:
      return 'orders.status.ready';
    case OrderStatus.Cancelled:
      return 'orders.status.cancelled';
    default:
      return 'orders.status.unknown';
  }
};
